import React, { Component } from 'react'

import Sizes from '../logic/Sizes'
import Hexagon from '../logic/Hexagon'
import HexTypes from './HexTypes'

import ArrowConnect from '../logic/ArrowConnect'
let newArr = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
let newArr3 = []
let newArr5 = []
let newArr7 = []

class HexBoard extends Component {
    constructor(props) {
        super(props)
        this.myRef = React.createRef()
    }
    shouldComponentUpdate(nextProps, nextState) {
        // Force update if the highlighted hex target changes
        if (
            JSON.stringify(this.props.highlightHex) !==
            JSON.stringify(nextProps.highlightHex)
        ) {
            return true
        }
        return nextProps.drawing.updated
    }
    simulateProgram = (time, newArray) => {
        this.myRef.current.play(time, newArray)
    }
    render() {
        const { drawing, onClick, onDoubleClick, highlightHex } = this.props

        let newId = 0
        return (
            <g transform={'translate(0,' + Sizes.r / 2 + ')'}>
                <style>
                    {`
                        @keyframes hexFlicker {
                            0%, 100% {
                                filter: drop-shadow(0 0 0px transparent);
                                opacity: 1;
                            }
                            50% {
                                filter: drop-shadow(0 0 3px black);
                                opacity: 0.7;
                            }
                        }

                        .highlight-hex-flicker {
                            animation: hexFlicker 1s ease-in-out infinite;
                        }
                    `}
                </style>

                {drawing.board.map((row, rIndex) => {
                    var xoff = 0
                    if (rIndex % 2 == 1) xoff += Sizes.xdiff / 2
                    return (
                        <g
                            transform={
                                'translate(' +
                                xoff +
                                ',' +
                                rIndex * Sizes.ydiff +
                                ')'
                            }
                            key={rIndex}
                        >
                            {row.map((cell, cIndex) => {
                                if (JSON.stringify(rIndex).charAt(0) == 1) {
                                    if (
                                        cell.type !== 'blank' &&
                                        (cell.type === 'hardware' ||
                                            cell.type === 'wait')
                                    ) {
                                        if (
                                            !newArr.includes(
                                                rIndex + '' + cIndex
                                            )
                                        ) {
                                            newArr.push(rIndex + '' + cIndex)
                                            sessionStorage.setItem(
                                                'Types',
                                                newArr
                                            )
                                        }
                                    }
                                }

                                if (JSON.stringify(rIndex).charAt(0) == 3) {
                                    if (
                                        cell.type !== 'blank' &&
                                        (cell.type === 'hardware' ||
                                            cell.type === 'wait')
                                    ) {
                                        if (
                                            !newArr3.includes(
                                                rIndex + '' + cIndex
                                            )
                                        ) {
                                            newArr3.push(rIndex + '' + cIndex)
                                            sessionStorage.setItem(
                                                'Types3',
                                                newArr3
                                            )
                                        }
                                    }
                                }

                                if (JSON.stringify(rIndex).charAt(0) == 5) {
                                    if (
                                        cell.type !== 'blank' &&
                                        (cell.type === 'hardware' ||
                                            cell.type === 'wait')
                                    ) {
                                        if (
                                            !newArr5.includes(
                                                rIndex + '' + cIndex
                                            )
                                        ) {
                                            newArr5.push(rIndex + '' + cIndex)
                                            sessionStorage.setItem(
                                                'Types5',
                                                newArr5
                                            )
                                        }
                                    }
                                }

                                // Check if this specific cell is the one the tutorial wants highlighted
                                const currentCellId = `hex-block-${rIndex}-${cIndex}`;
const isHighlighted = highlightHex === currentCellId;

                                return (
                                    <g
                                        id={currentCellId}
                                        key={`hex-wrapper-${rIndex}-${cIndex}`}
                                        className={
                                            isHighlighted
                                                ? 'highlight-hex-flicker'
                                                : ''
                                        }
                                        style={{
                                            transformOrigin: `${cIndex * Sizes.xdiff}px 0px`,
                                        }}
                                    >
                                        <Hexagon
                                            mode="make"
                                            cx={cIndex * Sizes.xdiff}
                                            hextype={cell.type}
                                            highlighted={cell.highlighted}
                                            row={rIndex}
                                            col={cIndex}
                                            onDoubleClick={onDoubleClick}
                                            onClick={
                                                cell.onClick
                                                    ? cell.onClick
                                                    : () =>
                                                          onClick(
                                                              rIndex,
                                                              cIndex
                                                          )
                                            }
                                            keys={
                                                cell.type === 'blank'
                                                    ? null
                                                    : rIndex === 1
                                                      ? rIndex + '' + newId++
                                                      : rIndex + '' + cIndex
                                            }
                                            id={rIndex}
                                            ref={this.myRef}
                                        />
                                    </g>
                                )
                            })}
                        </g>
                    )
                })}
                <g>
                    {drawing.connections.map((connection, key) => {
                        return (
                            <ArrowConnect
                                hex1r={connection.from[0]}
                                hex1c={connection.from[1]}
                                hex2r={connection.to[0]}
                                hex2c={connection.to[1]}
                                color={
                                    HexTypes[
                                        drawing.board[connection.from[0]][
                                            connection.from[1]
                                        ].type
                                    ].color
                                }
                                key={key}
                            />
                        )
                    })}
                </g>
            </g>
        )
    }
}

export default HexBoard
